<template>
  <div class="lives-orderlist">
    <Form :model="formItem"
          ref="formItem"
          :inline="true"
          action="javascript:void(0)">
      <FormItem>
        <DatePicker type="datetimerange"
                    format="yyyy-MM-dd"
                    :value="datePic"
                    @on-change="changeDate"
                    style="width: 200px"
                    placeholder="场次开始日期 - 结束时间日期"></DatePicker>
      </FormItem>
      <FormItem>
        <Select v-model="formItem.status"
                clearable
                filterable
                placeholder="订单状态...">
          <Option v-for="item in statusList"
                  :value="item.id"
                  :key="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Select v-model="formItem.fx_status"
                clearable
                filterable
                placeholder="核销状态...">
          <Option v-for="item in hexiaoList"
                  :value="item.id"
                  :key="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Select v-model="formItem.pay_status"
                clearable
                filterable
                placeholder="支付状态...">
          <Option v-for="item in payStatusList"
                  :value="item.id"
                  :key="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Select v-model="formItem.pay_name"
                clearable
                filterable
                placeholder="收单机构">
          <Option v-for="item in payNameList"
                  :value="item.id"
                  :key="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Input v-model="formItem.key"
               clearable
               placeholder="输入活动名称/支付单号/手机号查找..."
               style="width: 260px;"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary"
                @click="renderTable('formItem')">查找</Button>&nbsp;
        <Button type="success"
                :loading="exportLoading"
                @click="exportOrder()">导出约看订单</Button>
      </FormItem>
    </Form>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer title="审核"
            v-model="showModalStatus"
            width="800"
            scrollable
            @on-ok="createuser('userValidate')"
            :loading="loading"
            :mask-closable="false">
      <List>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">用户名:</span>
                {{dataInfo.user_name }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">支付单号:</span>
                {{dataInfo.order_num }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">活动:</span>
                {{dataInfo.lives_name }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">场次:</span>
                {{dataInfo.ticket_field_name }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">票:</span>
                {{dataInfo.ticket_title }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">数量:</span>
                {{dataInfo.nums }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">价格:</span>
                {{dataInfo.price }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <Row>
            <Col :xs="24"
                 :md="24">
            <Table border
                   stripe
                   :columns="orderservices"
                   :data="services"></Table>
            </Col>
          </Row>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">支付金额:</span>
                {{dataInfo.total_prices }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">用户备注:</span>
                {{dataInfo.mark }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">接待者:</span>
                {{dataInfo.receper_name }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">支付状态:</span>
                {{dataInfo.pay_status_name }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">支付时间:</span>
                {{dataInfo.pay_at }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <Row>
            <Col :xs="24"
                 :md="24">
            <Table border
                   stripe
                   :columns="paymethodmoney"
                   :data="paymoney"></Table>
            </Col>
          </Row>
        </ListItem>
        <ListItem v-for="(item,index) in enterArr"
                  :key="index">
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">{{ item.name }}:</span>
                {{ item.value }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">融宝支付返回code:</span>
                {{dataInfo.wxreturn_code }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">融宝返回信息:</span>
                {{dataInfo.wxreturn_msg }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">融宝回调返回信息:</span>
                {{dataInfo.wxreturn_msg2 }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">订单状态:</span>
                {{dataInfo.status_name }}
              </label>
            </li>
          </template>
        </ListItem>
      </List>
    </Drawer>
  </div>
</template>

<script>
export default {
  name: "lives-orderlist",
  data () {
    return {
      loading: true,
      dataloading: true,
      showModalStatus: false,
      exportLoading: false,
      datePic: [],
      thumblist: [],
      enterArr: [],
      paymoney: [],
      payNameList: [
        { id: 0, name: "融宝" },
        { id: 1, name: "财付通" },],
      statusList: [
        { id: 0, name: "已关闭" },
        { id: 1, name: "正常" },
      ],
      hexiaoList: [
        { id: 0, name: "未核销" },
        { id: 1, name: "已核销" }
      ],
      payStatusList: [
        { id: 0, name: "未支付" },
        { id: 1, name: "支付中" },
        { id: 2, name: "已完成" }
      ],
      title: "",
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "支付单号",
          key: "order_num",
          minWidth: 150
        },
        {
          title: "活动名称",
          key: "live_title",
          width: 150,
        },
        {
          title: "匠人",
          key: "tradesman_name",
          width: 150,
        },
        {
          title: "场次名称",
          key: "ticket_field_name",
          width: 150,
        },
        {
          title: "场次开始时间",
          key: "ticket_field_time",
          width: 150,
        },
        {
          title: "票名称",
          key: "ticket_title",
          width: 200,
          // render: (h, params) => {
          //   var name = "";
          //   params.row.data.forEach(function (el, index) {
          //     if (index > 0) {
          //       name += ",";
          //     }
          //     name += el.ticket_datas.tickets.title;
          //   });
          //   return h("div", [h("span", {}, name)]);
          // }
        },
        {
          title: "下单用户",
          key: "user_name",
          width: 150,
        },
        {
          title: "支付金额",
          key: "total_prices",
          width: 100
        },
        {
          title: "支付状态",
          key: "name",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.pay_status == 0
                  ? "未支付"
                  : params.row.pay_status == 1
                    ? "支付中"
                    : "已完成"
              )
            ]);
          }
        },
        {
          title: "支付时间",
          key: "pay_at",
          width: 100
        },
        {
          title: "支付方式",
          key: "pay_name",
          width: 100
        },
        {
          title: "订单状态",
          key: "name",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.status == 0 ? "取消" : "正常")
            ]);
          }
        },
        {
          title: "下单时间",
          key: "created_at",
          width: 150
        },
        {
          title: "核销码",
          key: "write_off_code",
          width: 150,
        },
        {
          title: "核销时间",
          key: "fx_at",
          width: 100,
        },
        {
          title: "操作",
          key: "action",
          width: 250,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.index, params.row.id);
                    }
                  }
                },
                "详情"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    display:
                      params.row.pay_status == 2 && params.row.status == 1 && params.row.fx_status == 0
                        ? "inline-block"
                        : "none"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.hexiao(params.row.id);
                    }
                  }
                },
                "核销"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    display:
                      params.row.status == 1 && params.row.fx_status == 0
                        ? "inline-block"
                        : "none"
                  },
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.cancel(params.row.id);
                    }
                  }
                },
                "取消"
              )
            ]);
          }
        }
      ],
      paymethodmoney: [
        {
          title: "余额",
          key: "user_money",
          fixed: "left",
          width: 90
        },
        {
          title: "充值卡",
          key: "charge_card_money",
          minWidth: 90
        },
        {
          title: "微信",
          key: "wx_money",
          minWidth: 90
        },
      ],
      orderservices: [
        {
          title: "服务",
          key: "name",
          fixed: "left",
          width: 150
        },
        {
          title: "金额",
          key: "price",
          minWidth: 90
        },
      ],
      services: [],
      tablelist: [],
      dataInfo: {
        name: "",
        prices: "",
        descript: ""
      },
      showModalStatus: false,
      datetime: [],
    };
  },
  // 组件
  components: {},
  created: function () {

    // 取数据
    this.formItem.pay_status = this.$route.params.pay_status != -1 ? parseInt(this.$route.params.pay_status) : null;
    this.formItem.ship_status = this.$route.params.ship_status != -1 ? parseInt(this.$route.params.ship_status) : null;
    this.formItem.status = this.$route.params.status != -1 ? parseInt(this.$route.params.status) : null;
    this.getTableList();
  },
  methods: {
    getTableList: function () {
      this.$api.livesorder
        .list({
          page: this.pages.page, size: this.pages.size, pay_status: this.formItem.pay_status,
          ship_status: this.formItem.ship_status, 'status': this.formItem.status
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            if (res.result.list != null) {
              this.tablelist = res.result.list;
            } else {
              this.tablelist = [];
            }
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
    },
    //核销
    hexiao: function (index) {
      this.$api.livesorder
        .verify({
          id: index
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.$api.livesorder
              .hexiao({
                id: index
              })
              .then(res => {
                this.dataloading = false;
                if (res.code == 200) {
                  this.getTableList();
                  this.$Message.success(res.msg);
                }
              });
          } else {
            this.$Modal.confirm({
              title: "警告",
              content: res.msg,
              onOk: () => {
                this.$api.livesorder
                  .hexiao({
                    id: index
                  })
                  .then(res => {
                    this.dataloading = false;
                    if (res.code == 200) {
                      this.getTableList();
                    }
                  });
              }
            });
          }
        });
    },
    // hexiao: function (index) {
    //   this.$Modal.confirm({
    //     title: "警告",
    //     content: "<p>此操作不可恢复，三思而后行...</p>",
    //     onOk: () => {
    //       this.$api.livesorder
    //         .hexiao({
    //           id: index
    //         })
    //         .then(res => {
    //           this.dataloading = false;
    //           if (res.code == 200) {
    //             this.getTableList();
    //             this.$Message.success(res.msg);
    //           }
    //         });
    //     }
    //   });
    // },
    changeDate (val) {
      this.datetime = val;
    },
    cancel: function (index) {
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.livesorder.cancel({
            id: index
          }).then(res => {
            if (res.code == 200) {
              this.getTableList();
              this.$Message.success(res.msg);
            }
          });
        }
      });
    },
    // 详情
    detail (index, id) {
      this.title = "详情";
      this.showModalStatus = !this.showModalStatus;
      this.$api.livesorder.detail({ id: id }).then(res => {
        this.dataInfo = res.result;
        this.dataInfo.user_name = res.result.user_name;
        this.dataInfo.lives_name = res.result.live_title;
        this.dataInfo.ticket_field_name = res.result.ticket_field_name;
        this.paymoney = res.result.paymoneys;
        this.services = res.result.orderservice;
        let arr = [];
        let info = JSON.parse(res.result.enter_info);

        for (var i in info) {
          let obj = info[i];
          for (let j in obj) {
            let obj1 = {
              name: j,
              value: obj[j]
            };
            arr.push(obj1)
          }
        }
        this.enterArr = arr;
        // var name = "";
        // res.result.data.forEach(function (el, index) {
        //   if (index > 0) {
        //     name += ",";
        //   }
        //   name += el.ticket_datas.tickets.title;
        // });
        // this.dataInfo.ticket_name = name;
        console.log(res.result.pay_status)
        this.dataInfo.pay_status_name =
          res.result.pay_status.toString() == "1"
            ? "支付中"
            : res.result.pay_status.toString() == "0"
              ? "未完成"
              : "已完成";
        this.dataInfo.status_name = res.result.status.toString() == "1" ? "正常" : "取消";
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      var bgn_date =
        this.datetime[0] != undefined ? this.datetime[0] : "";
      var end_date =
        this.datetime[1] != undefined ? this.datetime[1] : "";
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        fx_status: this.formItem.fx_status,
        pay_status: this.formItem.pay_status,
        pay_name: this.formItem.pay_name,
        status: this.formItem.status,
        bgn_date: bgn_date,
        end_date: end_date,
      };
      this.$api.livesorder.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          if (res.result.list != null) {
            this.tablelist = res.result.list;
          } else {
            this.tablelist = [];
          }
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    },
    exportOrder () {
      this.exportLoading = true;
      var bgn_date =
        this.datetime[0] != undefined ? this.datetime[0] : "";
      var end_date =
        this.datetime[1] != undefined ? this.datetime[1] : "";
      this.$api.livesorder
        .export({
          key: this.formItem.key,
          fx_status: this.formItem.fx_status,
          pay_status: this.formItem.pay_status,
          status: this.formItem.status,
          pay_name: this.formItem.pay_name,
          bgn_date: bgn_date,
          end_date: end_date,
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
          }
          this.exportLoading = false;
        });
    },
  }
};
</script>